// extracted by mini-css-extract-plugin
export default {"wrapper":"Xo-z","response":"Yo-z","error":"Zo-z","disabled":"_o-z","buttons":"ap-z","feedbackQuestionSection":"bp-z","yesNoWrapper":"cp-z"};